import React from 'react'

import { UserRecipePhoto } from '@/api/types'
import { Flex } from '@/components/Flex'
import { Grid } from '@/components/Grid'
import RecipePhotoItem from './RecipePhotoItem'
import useRecipePhoto from './useRecipePhoto'

type Props = {
  photos: UserRecipePhoto[]
  idRecipe: number
}

const UPLOAD_PLACEHOLDER = {
  idRecipePhoto: -1,
  photoPath: '',
  thumbnailPath: '',
} as unknown as UserRecipePhoto

export default function PhotosView({ idRecipe, photos }: Props) {
  const { deletePhoto, approvePhoto, rejectPhoto, setAsCover } = useRecipePhoto(idRecipe)

  return (
    <Flex gap={20} direction="column">
      <Grid columns="repeat(6, 1fr)" style={{ width: '100%' }}>
        {[UPLOAD_PLACEHOLDER, ...photos].map((photo) => (
          <RecipePhotoItem
            key={photo.idRecipePhoto}
            photo={photo}
            idRecipe={idRecipe}
            onApprove={() => approvePhoto(photo.idRecipePhoto)}
            onReject={() => rejectPhoto(photo.idRecipePhoto)}
            onDelete={() => deletePhoto(photo.idRecipePhoto)}
            onSetAsCover={() => setAsCover(photo.idRecipePhoto)}
          />
        ))}
      </Grid>

      {/* <Flex gap={20} direction="column">
        <Heading>{t('photos.userPhotos')}</Heading>
        {userPhotos.length === 0 ? (
          <p>{t('photos.noPhotos')}</p>
        ) : (
          <Grid columns="repeat(6, 1fr)">
            {userPhotos.map((photo) => (
              <RecipePhotoItem
                key={photo.idRecipePhoto}
                photo={photo}
                idRecipe={idRecipe}
                onDelete={handleDeletePhoto}
              />
            ))}
          </Grid>
        )}
      </Flex> */}
    </Flex>
  )
}
